import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { ComponentProps, FC } from 'react';
import { JourneyPickerConnected as JourneyPickerV1 } from '../JourneyPicker/container';
import { JourneyPickerV2Connected } from './container';
import { useCategoryNavigation } from './useCategoryNavigation';
import { useCurrentCategory } from './useCurrentCategory';
import { useNavCategories } from './useNavCategories';

type V1Props = ComponentProps<typeof JourneyPickerV1>;

export const JourneyPickerVersion: FC<V1Props> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  const categories = useNavCategories();
  const handleCategoryChange = useCategoryNavigation();
  const currentCategory = useCurrentCategory();

  if (isV2) {
    return (
      <JourneyPickerV2Connected
        dateMode="range"
        dateContext="stay"
        category={currentCategory}
        categories={categories}
        onCategoryChange={handleCategoryChange}
        onChange={props.onChange}
      />
    );
  }

  return <JourneyPickerV1 {...props} />;
};
